/* ============ Sauwer theme JS ============ */
(function () {
  // Smooth scroll for anchor links, offset by sticky nav height
  document.querySelectorAll('a[href*="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const hash = link.getAttribute('href').split('#')[1];
      if (!hash) return;
      const target = document.getElementById(hash);
      if (!target) return;
      e.preventDefault();
      const navEl = document.querySelector('[data-nav]');
      const offset = navEl ? navEl.offsetHeight + 16 : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
      history.pushState(null, '', '#' + hash);
    });
  });

  // Smooth scroll to top for "Inicio" link when already on homepage
  document.querySelectorAll('a[href="/"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (window.location.pathname !== '/') return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      history.pushState(null, '', '/');
    });
  });

  // Sticky nav scroll state
  const nav = document.querySelector('[data-nav]');
  if (nav) {
    const onScroll = () => nav.classList.toggle('nav--scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // FAQ acordeón
  document.querySelectorAll('[data-faq] [data-faq-q]').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('[data-faq-item]');
      const a = item.querySelector('.faq__a');
      const open = !a.hasAttribute('hidden');
      // cerrar todas
      document.querySelectorAll('[data-faq] .faq__a').forEach((x) => x.setAttribute('hidden', ''));
      document.querySelectorAll('[data-faq] [data-faq-item]').forEach((x) => x.classList.remove('faq__item--open'));
      if (!open) {
        a.removeAttribute('hidden');
        item.classList.add('faq__item--open');
      }
    });
  });

  // Cambio de variante en product cards — selección por grupos de opciones
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const optionsEl = card.querySelector('[data-options]');
    if (!optionsEl) return;
    const variants = JSON.parse(optionsEl.dataset.variants || '[]');
    const priceEl = card.querySelector('[data-card-price]');
    const variantInput = card.querySelector('[data-card-variant]');
    const badge = card.querySelector('[data-card-badge]');
    const cardImg = card.querySelector('.card__bottle img');

    function getSelected() {
      return Array.from(optionsEl.querySelectorAll('[data-option-group]')).map((group) => {
        const active = group.querySelector('.size-pill--active');
        return active ? active.dataset.optVal : null;
      });
    }

    optionsEl.querySelectorAll('.size-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        const idx = pill.dataset.optIdx;
        optionsEl.querySelectorAll(`.size-pill[data-opt-idx="${idx}"]`)
          .forEach((p) => p.classList.remove('size-pill--active'));
        pill.classList.add('size-pill--active');

        const sel = getSelected();
        const match = variants.find((v) =>
          sel.every((val, i) => val === null || v['option' + (i + 1)] === val)
        );
        if (!match) return;
        if (priceEl) priceEl.textContent = '$ ' + (match.price / 100).toFixed(2);
        if (variantInput) variantInput.value = match.id;
        if (badge) badge.textContent = match.title;
        const newSrc = match.featured_image ? match.featured_image.src : null;
        if (cardImg && newSrc) {
          cardImg.style.opacity = '0';
          setTimeout(() => {
            cardImg.srcset = '';
            cardImg.src = newSrc;
            cardImg.style.opacity = '1';
          }, 150);
        }
      });
    });
  });

  // Product page: option selectors → swap variant
  const productSection = document.querySelector('[data-product-section]');
  if (productSection && window.__product) {
    const product = window.__product;
    const optionGroups = productSection.querySelectorAll('[data-option-index]');
    const variantInput = productSection.querySelector('[data-variant-id]');
    const priceEl = productSection.querySelector('[data-price]');
    const selected = product.options.map((_, i) => {
      const first = productSection.querySelector(`[data-option-index="${i}"].size-pill--active`);
      return first ? first.dataset.optionValue : product.options_with_values[i].selected_value;
    });

    productSection.querySelectorAll('.size-pill').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIndex, 10);
        selected[idx] = btn.dataset.optionValue;
        // toggle active dentro del mismo grupo
        productSection.querySelectorAll(`.size-pill[data-option-index="${idx}"]`)
          .forEach((p) => p.classList.remove('size-pill--active'));
        btn.classList.add('size-pill--active');
        // encontrar variante
        const match = product.variants.find((v) => {
          return (!v.option1 || v.option1 === selected[0])
              && (!v.option2 || v.option2 === selected[1])
              && (!v.option3 || v.option3 === selected[2]);
        });
        if (match) {
          if (variantInput) variantInput.value = match.id;
          if (priceEl) {
            const price = (match.price / 100).toFixed(2);
            priceEl.textContent = '$' + price + ' MXN';
          }
          // Cambiar imagen de galería según variante
          const variantImg = btn.dataset.variantImg;
          if (variantImg) {
            const thumb = productSection.querySelector(`.pdp__thumb[data-src="${variantImg}"]`);
            if (thumb) {
              thumb.click();
            } else {
              const mainImg = document.getElementById('pdp-main-img');
              if (mainImg) mainImg.src = variantImg;
            }
          }
        }
      });
    });
  }
})();
